import React from 'react';
import { useIntl } from 'react-intl';
import { API } from '@gin-betting/core';

import { FlagIcon } from 'components';
import { getItemsByLocation } from '../../../../utils';
import CategorizerSubRow from '../../CategorizerSubRow';
import { CheckRowList } from '../CheckRowList';

interface Props {
    tournaments: API.CategorizerItem[];
    topCategorizerItem: API.CategorizerItem;
    sportId: string;
    selectedTournamentIds: string[];
    isTournamentManuallyChecked: boolean;
    isAllItemsInSportChecked: boolean;
    onTournamentsChecked: (tournamentIds: string[]) => void;
    onTournamentIdsChange: (nextTournamentIds: string[]) => void;
}

const LocationRow: React.FC<Props> = ({
    sportId,
    tournaments,
    selectedTournamentIds,
    isAllItemsInSportChecked,
    isTournamentManuallyChecked,
    topCategorizerItem,
    onTournamentsChecked,
    onTournamentIdsChange,
}) => {
    const { formatMessage } = useIntl();

    const {
        tournamentsWithLocation,
        tournamentsWithoutLocation,
    } = getItemsByLocation({
        tournaments,
        sportId,
        formatMessage,
    });

    return (
        <React.Fragment>
            {tournamentsWithLocation.map(
                ({ items, countryName, countryCode }) => (
                    <CategorizerSubRow
                        key={countryCode}
                        label={countryName}
                        countryCode={countryCode}
                        items={items}
                        topCategorizerItem={topCategorizerItem}
                        selectedTournamentIds={selectedTournamentIds}
                        isAllItemsInSportChecked={isAllItemsInSportChecked}
                        isGroupWithOneItem={
                            tournamentsWithLocation.length === 1
                        }
                        onTournamentIdsChange={onTournamentIdsChange}
                        additionalIcon={<FlagIcon countryCode={countryCode} />}
                    />
                )
            )}

            <div>
                <CheckRowList
                    items={tournamentsWithoutLocation}
                    isTournamentManuallyChecked={isTournamentManuallyChecked}
                    selectedTournamentIds={selectedTournamentIds}
                    isAllItemsInSportChecked={isAllItemsInSportChecked}
                    onTournamentsChecked={onTournamentsChecked}
                    hasSiblingSubgroups={tournamentsWithLocation.length > 0}
                />
            </div>
        </React.Fragment>
    );
};

export default LocationRow;
